<template>
<div class="chapter">
<div class="inner_page">
<div class="booksby" id="booksby">
<div class="chapterHead">
<h2 class="chapterTitleB-1">Books by Jerome A. Greene</h2>
</div>
<p class="altPara1"><em class="italic">Evidence and the Custer Enigma: A Reconstruction of Indian-Military History</em> (Kansas City, 1973)</p>
<p class="altPara2"><em class="italic">Slim Buttes, 1876: An Episode of the Great Sioux War</em> (Norman, 1982)</p>
<p class="altPara2"><em class="italic">Yellowstone Command: Colonel Nelson A. Miles and the Great Sioux War, 1876-1877</em>(Lincoln, 1991; Norman, 2006)</p>
<p class="altPara2"><em class="italic">Battles and Skirmishes of the Great Sioux War, 1876-1877: The Military View</em> (Norman, 1993)</p>
<p class="altPara2"><em class="italic">Lakota and Cheyenne: Indian Views of the Great Sioux War, 1876-1877</em> (Norman, 1994)</p>
<p class="altPara2"><em class="italic">Frontier Soldier: An Enlisted Man’s Journal of the Sioux and Nez Perce Campaigns, 1877</em> (Helena, 1998)</p>
<p class="altPara2"><em class="italic">Nez Perce Summer, 1877: The U. S. Army and the Nee-Me-Poo Crisis</em> (Helena, 2000)</p>
<p class="altPara2"><em class="italic">Morning Star Dawn: The Powder River Expedition and the Northern Cheyennes, 1876</em>(Norman, 2003)</p>
<p class="altPara2"><em class="italic">Washita: The U. S. Army and the Southern Cheyennes, 1867-1869</em> (Norman, 2004)</p>
<p class="altPara2">(Co-author with Douglas D. Scott) <em class="italic">Finding Sand Creek: History, Archeology, and the 1864 Massacre Site</em> (Norman, 2004)</p>
<p class="altPara2"><em class="italic">The Guns of Independence: The Siege of Yorktown</em>, 1781 (New York and Staplehurst, UK, 2005)</p>
<p class="altPara2"><em class="italic">Fort Randall on the Missouri, 1856-1892</em>(Pierre, 2005)</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// IndianWarVeterans_booksby.vue?50028b07